export const GET_PRISM_VERSION = 'GET_PRISM_VERSION';
export const PRISM_VERSION = 'PRISM_VERSION';
export const CUSTOM_LOGIN = 'CUSTOM_LOGIN';
export const GET_WELCOME_BANNER = 'GET_WELCOME_BANNER';
export const WELCOME_BANNER_HAS_TRIGGERED = 'WELCOME_BANNER_HAS_TRIGGERED';
export const GET_PRISM_LOGIN_CUSTOM = 'GET_PRISM_LOGIN_CUSTOM';
export const GET_PROVIDERS_LIST = 'GET_PROVIDERS_LIST';
